import { render } from "./fourthstepGrooming.vue?vue&type=template&id=61750de8&scoped=true"
import script from "./fourthstepGrooming.vue?vue&type=script&lang=js"
export * from "./fourthstepGrooming.vue?vue&type=script&lang=js"

import "./fourthstepGrooming.vue?vue&type=style&index=0&id=61750de8&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61750de8"]])

export default __exports__